<template>
    <form class="form pb-5">
        <div class="d-flex align-items-center mb-1">
            <div class="image-block image-block--rounded--lg mb-4">
                <img v-if="logo" :src="logo" alt="img">
            </div>
            <div>
                <a @click="showLogoUpload = true" class="btn btn-primary">Upload Logo</a>
                <p class="modal-text m-0">Image size: 200 X 200 pixels, max file size 5 mb</p>
            </div>
        </div>

        <image-upload
            v-model="showLogoUpload"
            :width="200"
            :height="200"
            :noSquare="true"
            langType="en"
            @crop-success="logoCropped"
        >
        </image-upload>

        <b-row>
            <b-col cols="12">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Website URL*</h5>
                    <span class="form__error" v-if="errors.url.length">{{errors.url.join(', ')}}</span>
                    <input class="form-control--mid form-control" type="text" v-model="form.url_domain">
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Funding</h5>
                    <span class="form__error" v-if="errors.total_raised.length">{{errors.total_raised.join(', ')}}</span>
                    <input class="form-control--mid form-control" type="text" v-model="form.total_raised">
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Employees*</h5>

                    <span class="form__error" v-if="errors.employees.length">{{errors.employees.join(', ')}}</span>
                    <select v-model="employees" class="selectbox selectbox-mid w-100">
                        <option v-for="(name, value) in employeesFilter" :key="value" :value="value">
                            {{value}}
                        </option>
                    </select>

                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Country*</h5>
                    <span class="form__error" v-if="errors.country.length">{{errors.country.join(', ')}}</span>
                    <multiselect
                        v-model="country"
                        placeholder="Select Country"
                        :options="countriesList"
                        select-label=""
                        deselect-label=""
                        label="name"
                        track-by="name"
                        class="multiselect-mid pl-2"
                    >
                    </multiselect>
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item" v-if="form.country_id == 1">
                    <h5 class="heading5 heading5--secondary">State*</h5>

                    <span class="form__error" v-if="errors.state.length">{{errors.state.join(', ')}}</span>
                    <multiselect
                        v-model="state"
                        placeholder="Select State"
                        :options="statesList"
                        select-label=""
                        deselect-label=""
                        label="name"
                        track-by="name"
                        class="multiselect-mid pl-2"
                    >
                    </multiselect>
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">City*</h5>

                    <span class="form__error" v-if="errors.city.length">{{errors.city.join(', ')}}</span>
                    <input class="form-control--mid form-control" type="text" v-model="form.city">
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Funding Round*</h5>

                    <select v-model="form.stage" class="selectbox selectbox-mid w-100">
                        <option v-for="(value, index) in fundingFilter" :key="index" :value="value">
                            {{value}}
                        </option>
                    </select>

                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Year Founded*</h5>
                    <span class="form__error" v-if="errors.founded.length">{{errors.founded.join(', ')}}</span>

                    <input class="form-control--mid form-control" type="number" v-model="form.founded">
                </div>
            </b-col>
            <b-col cols="12" sm="6">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Revenue Range</h5>

                    <select v-model="form.revenue_range" class="selectbox selectbox-mid w-100">
                        <option v-for="(name, value) in revenueFilter" :key="value" :value="value">
                            {{name}}
                        </option>
                    </select>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Company Description*</h5>
                    <span class="form__error" v-if="errors.description.length">{{errors.description.join(', ')}}</span>

                    <textarea class="form-control--mid form-control" v-model="form.description">

                    </textarea>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="form__item">
                    <h5 class="heading5 heading5--secondary">Categories*</h5>
                    <span class="form__error" v-if="errors.categories.length">{{errors.categories.join(', ')}}</span>
                    <div class="form__item">
                        <multiselect
                            v-model="form.categories"
                            :multiple="true"
                            placeholder="Select Categories"
                            :options="$store.state.categories"
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            class="multiselect-mid pl-2"
                        >
                        </multiselect>
                    </div>
                </div>
            </b-col>
        </b-row>
        <div class="text-center">
            <b-button v-if="!loading" variant="primary" size="lg" @click="save">Continue to Application</b-button>
            <b-button v-else variant="primary" size="lg" disabled>Saving Profile...</b-button>
        </div>

    </form>
</template>

<script>
import filterOptions from '@/components/search/filter-options'
import locations from "@/services/locations.service"
import profile from "@/services/startup/profile.service"
import multiselect from "vue-multiselect";
import imageUpload from "vue-image-crop-upload";

export default {
    components: {
        multiselect,
        imageUpload,
    },

    mixins: [
        filterOptions
    ],

    data() {
        return {
            form: {
                url_domain: "",
                total_raised: "",
                stage: "",
                country_id: null,
                state_id: null,
                city: "",
                founded: "",
                revenue_range: "",
                description: "",
                categories: [],
                num_employees_min: 0,
                num_employees_max: 0,

            },

            loading: false,
            logo: "",
            showLogoUpload: false,
            logoChanged: false,

            employees: null,
            country: null,
            state: null,
            countriesList: [],
            statesList: [],

            errors: {
                url: "",
                total_raised: "",
                employees: "",
                country: "",
                state: "",
                city: "",
                founded: "",
                description: "",
                categories: "",
                logo: "",
            },
        }
    },

    watch: {
        country() {
            if (this.country) {
                this.form.country_id = this.country.id
            }
            else {
                this.form.country_id = 0
            }
        },

        state() {
            if (this.state) {
                this.form.state_id = this.state.id
            }
            else {
                this.form.state_id = 0
            }
        },
    },

    computed: {
        employeesFilter() {
            let list = {}

            this.filtersOptions.employeeCount.forEach(item => {
                if (item.name != "Unknown") {
                    list[item.name] = {
                        min: item.value.min,
                        max: item.value.max,
                    }
                }
            })

            return list
        },

        fundingFilter() {
            let list = []

            this.filtersOptions.fundingSeries.forEach(item => {
                list.push(item.name)
            })

            return list
        },

        revenueFilter() {
            let list = {}

            this.filtersOptions.revenueRange.forEach(item => {
                list[item.value] = item.name
            })

            return list
        },
    },

    mounted() {
        locations.getCountriesList().then(response => {
            this.countriesList = response.data
            this.setCountry()
        })

        locations.getStatesList().then(response => {
            this.statesList = response.data
            this.setState()
        })

        this.getInfo()
    },

    methods: {
        getInfo() {
            profile.getInfo().then(response => {
                this.form.url_domain = response.data.url_domain
                this.form.total_raised = response.data.total_raised
                let employees_min = response.data.num_employees_min
                let employees_max = response.data.num_employees_max

                this.filtersOptions.employeeCount.forEach(item => {
                    if (item.value.min == employees_min && item.value.max == employees_max) {
                        this.employees = item.name
                        return
                    }
                })

                this.form.country_id = response.data.country_id
                this.setCountry()

                this.form.state_id = response.data.state_id
                this.setState()

                this.form.city = response.data.city
                this.form.stage = response.data.stage
                this.form.founded = response.data.founded
                this.form.revenue_range = response.data.revenue_range
                this.form.description = response.data.description
                this.form.categories = response.data.categories
                this.logo = response.data.logo
            })
        },

        setCountry() {
            if (!this.country && this.form.country_id) {
                this.countriesList.forEach(item => {
                    if (item.id == this.form.country_id) {
                        this.country = item
                        return
                    }
                })
            }
        },

        setState() {
            if (!this.state && this.form.state_id) {
                this.statesList.forEach(item => {
                    if (item.id == this.form.state_id) {
                        this.state = item
                        return
                    }
                })
            }
        },

        save() {
            this.loading = true;

            if (this.employees) {
                let employeesCounts = this.employeesFilter[this.employees]
                this.form.num_employees_min = employeesCounts.min
                this.form.num_employees_max = employeesCounts.max
            }

            if (this.logoChanged) {
                this.form.newLogo = this.logo
            }

            profile.saveInfo(this.form).then(response => {
                this.clearErrors()

                if (Object.keys(response.data.errors).length) {
                    for (let attr in response.data.errors) {
                        this.errors[attr] = response.data.errors[attr]
                    }

                } else {
                    this.$emit('saved')
                }
            }).finally(() => {
                this.loading = false
            })
        },

        clearErrors() {
            for (let i in this.errors) {
                this.errors[i] = ""
            }
        },

        logoCropped(imageDataUrl) {
            this.logo = imageDataUrl
            this.showAvatarUpload = false
            this.logoChanged = true
        }
    }
}
</script>

<style scoped>

</style>
